/**
 * Mapeamento de códigos de país para arquivos de bandeiras SVG
 * Resolve os 404 convertendo códigos IOC/FIFA para nomes de arquivos corretos
 */
import React from 'react';

// Mapeamento de códigos de país para nomes de arquivos
const FLAG_MAPPING = {
  // Códigos ISO padrão que funcionam direto
  'BRA': 'BRA',
  'USA': 'USA',
  'AUS': 'AUS',
  'GBR': 'GBR',
  'FRA': 'FRA',
  'GER': 'GER',
  'ITA': 'ITA',
  'ESP': 'ESP',
  'CAN': 'CAN',
  'JPN': 'JPN',
  'CHN': 'CHN',
  'KOR': 'KOR',
  'NED': 'NED',
  'SWE': 'SWE',
  'NOR': 'NOR',
  'DEN': 'DEN',
  'FIN': 'FIN',
  'POL': 'POL',
  'RUS': 'RUS',
  'UKR': 'UKR',
  'RSA': 'RSA',
  'NZL': 'NZL',
  'ARG': 'ARG',
  'MEX': 'MEX',
  'CHI': 'CHI',
  'COL': 'COL',
  'VEN': 'VEN',
  'PER': 'PER',
  'ECU': 'ECU',
  'URU': 'URU',
  'PAR': 'PAR',
  'BOL': 'BOL',
  'CRC': 'CRC',
  'PAN': 'PAN',
  'CUB': 'CUB',
  'DOM': 'DOM',
  'PUR': 'PUR',
  'JAM': 'JAM',
  'TRI': 'TRI',
  'GUA': 'GUA',
  'HON': 'HON',
  'NCA': 'NCA',
  'ESA': 'ESA',
  'HAI': 'HAI',
  'BER': 'BER',
  'BAH': 'BAH',
  'BAR': 'BAR',
  'ANT': 'ANT',
  'ARU': 'ARU',
  'CAY': 'CAY',
  'ISV': 'ISV',
  'IVB': 'IVB',
  'VIN': 'VIN',
  'LCA': 'LCA',
  'GRN': 'GRN',
  'SKN': 'SKN',
  'DMA': 'DMA',
  'ANT': 'ANT',
  
  // Mapeamentos especiais (códigos que precisam conversão)
  'LKA': 'sri-lanka', // Sri Lanka
  'AQU': 'anguilla', // Anguilla
  'NMA': 'northern-mariana-islands', // Northern Mariana Islands
  'NGR': 'nigeria', // Nigeria
  'BUL': 'bulgaria', // Bulgaria
  'SLO': 'slovenia', // Slovenia
  'INA': 'indonesia', // Indonesia
  'MAW': 'malawi', // Malawi
  'BAR': 'barbados', // Barbados
  'TTO': 'trinidad-tobago', // Trinidad e Tobago
  'IRI': 'iran', // Irã
  'LBA': 'libya', // Líbia
  'SMF': 'samoa', // Samoa
  'Coréia': 'south-korea', // Coreia do Sul
  'Brunei': 'brunei',
  'TCN': 'turks-caicos', // Turks and Caicos
  'PLW': 'palau',
  'FRO': 'faroe-islands', // Ilhas Faroe
  'FSM': 'micronesia',
  'Kosovo': 'kosovo',
  'NAA': 'nauru',
  'NIA': 'nicaragua',
  'GEQ': 'equatorial-guinea', // Guiné Equatorial
  'ART - Participantes Independentes AQUA': 'neutral-athletes',
  'Timor-Leste': 'timor-leste',
  'BUR': 'burkina-faso', // Burkina Faso
  'CUR': 'curacao',
  'MON': 'monaco',
  'O Salvador': 'el-salvador',
  'São Luís Vicente e Granadinas': 'saint-vincent-grenadines',
  'República Democrática Popular do Laos': 'laos',
  'Bósnia-Herzegovina': 'bosnia-herzegovina',
  'Suazilândia': 'eswatini', // Suazilândia/Eswatini
  'ART': 'neutral-athletes', // Atletas neutros
  'Eles. República do Congo': 'republic-congo',
  'Equipe de Refugiados AQUA': 'refugee-team',
  'GBS': 'guinea-bissau',
  'MHL': 'marshall-islands',
  'Ilhas Virgens': 'virgin-islands',
  'Malawi': 'malawi',
  'Maurício': 'mauritius',
  'Mauritânia': 'mauritania',
  'I. R. Irã': 'iran',
  'MYS': 'malaysia',
  'AGU': 'antigua-barbuda',
  'BIZ': 'belize',
  'Iémen': 'yemen',
  'São Marino': 'san-marino',
  'REN': 'reunion',
  'PHL': 'philippines',
  'São Luís, Cristóvão e Névis': 'saint-kitts-nevis',
  
  // Códigos de 3 letras comuns
  'ENG': 'england',
  'SCO': 'scotland',
  'WAL': 'wales',
  'NIR': 'northern-ireland',
  'IRL': 'ireland',
  'POR': 'portugal',
  'BEL': 'belgium',
  'SUI': 'switzerland',
  'AUT': 'austria',
  'HUN': 'hungary',
  'CZE': 'czech-republic',
  'SVK': 'slovakia',
  'ROU': 'romania',
  'GRE': 'greece',
  'TUR': 'turkey',
  'EGY': 'egypt',
  'MAR': 'morocco',
  'ALG': 'algeria',
  'TUN': 'tunisia',
  'KEN': 'kenya',
  'ETH': 'ethiopia',
  'GHA': 'ghana',
  'NIG': 'niger',
  'SEN': 'senegal',
  'CIV': 'ivory-coast',
  'CMR': 'cameroon',
  'ZIM': 'zimbabwe',
  'UGA': 'uganda',
  'TAN': 'tanzania',
  'ZAM': 'zambia',
  'BOT': 'botswana',
  'NAM': 'namibia',
  'MOZ': 'mozambique',
  'ANG': 'angola',
  'ISR': 'israel',
  'JOR': 'jordan',
  'LIB': 'lebanon',
  'SYR': 'syria',
  'IRQ': 'iraq',
  'KUW': 'kuwait',
  'QAT': 'qatar',
  'UAE': 'uae',
  'SAU': 'saudi-arabia',
  'OMA': 'oman',
  'BAH': 'bahrain',
  'YEM': 'yemen',
  'PAK': 'pakistan',
  'IND': 'india',
  'BAN': 'bangladesh',
  'SRI': 'sri-lanka',
  'NEP': 'nepal',
  'MGL': 'mongolia',
  'KAZ': 'kazakhstan',
  'UZB': 'uzbekistan',
  'TKM': 'turkmenistan',
  'KGZ': 'kyrgyzstan',
  'TJK': 'tajikistan',
  'AFG': 'afghanistan',
  'THA': 'thailand',
  'VIE': 'vietnam',
  'SIN': 'singapore',
  'HKG': 'hong-kong',
  'MAC': 'macau',
  'TPE': 'taiwan',
  'PRK': 'north-korea',
  'PHI': 'philippines',
  'MAS': 'malaysia',
  'BRU': 'brunei',
  'MYA': 'myanmar',
  'LAO': 'laos',
  'CAM': 'cambodia',
  'TLS': 'timor-leste',
  'PNG': 'papua-new-guinea',
  'SOL': 'solomon-islands',
  'VAN': 'vanuatu',
  'FIJ': 'fiji',
  'SAM': 'samoa',
  'TON': 'tonga',
  'COK': 'cook-islands',
  'ASA': 'american-samoa',
  'GUM': 'guam',
  'KIR': 'kiribati',
  'TUV': 'tuvalu',
  'NAU': 'nauru',
  'NRU': 'nauru',
  'PLW': 'palau',
};

/**
 * Retorna o caminho correto da bandeira para um código de país
 * @param {string} countryCode - Código do país (ex: 'BRA', 'USA', 'Sri Lanka')
 * @returns {string} - Caminho relativo da bandeira
 */
export function getFlagPath(countryCode) {
  if (!countryCode) return '/flags/default.svg';
  
  // Remove espaços e normaliza
  const code = countryCode.trim();
  
  // Verifica se existe mapeamento direto
  const mapped = FLAG_MAPPING[code];
  if (mapped) {
    return `/flags/${mapped}.svg`;
  }
  
  // Tenta usar o código diretamente (lowercase)
  return `/flags/${code.toLowerCase()}.svg`;
}

/**
 * Retorna o caminho da bandeira com fallback para PNG
 * @param {string} countryCode - Código do país
 * @returns {string} - Caminho da bandeira
 */
export function getFlagPathWithFallback(countryCode) {
  const svgPath = getFlagPath(countryCode);
  return svgPath;
}

/**
 * Componente de imagem de bandeira com fallback automático
 */
export const FlagImage = ({ countryCode, alt, className = "w-6 h-6 object-contain" }) => {
  const [currentSrc, setCurrentSrc] = React.useState(getFlagPath(countryCode));
  const [hasError, setHasError] = React.useState(false);

  const handleError = (e) => {
    if (!hasError) {
      // Primeira tentativa: PNG
      const pngPath = getFlagPath(countryCode).replace('.svg', '.png');
      if (currentSrc !== pngPath) {
        setCurrentSrc(pngPath);
        return;
      }
    }
    
    // Se tudo falhar, usa bandeira padrão
    if (currentSrc !== '/flags/default.svg') {
      setCurrentSrc('/flags/default.svg');
      setHasError(true);
    }
  };

  // Reset quando código mudar
  React.useEffect(() => {
    setCurrentSrc(getFlagPath(countryCode));
    setHasError(false);
  }, [countryCode]);

  return (
    <img 
      src={currentSrc}
      alt={alt || countryCode}
      className={className}
      onError={handleError}
      loading="lazy"
    />
  );
};

export default { getFlagPath, getFlagPathWithFallback, FlagImage };
